var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerSatisfaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 175,
    viewBox: "0 0 160 175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(-2987 -2563)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 160,
    height: 175,
    transform: "translate(2987 2563)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(-153.068 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M97.8,68.864a11.33,11.33,0,0,1-1.513,3.027c0,1.892-2.649,5.3-3.4,6.811A43.645,43.645,0,0,1,82.666,88.918,56.986,56.986,0,0,1,76.234,92.7c-.757.757-4.541,1.892-6.054,2.27l-3.784.757L64.5,96.1c-1.135,0-1.892.378-3.027,0-.757.757-4.162.757-4.919,0h-4.54c0-.378-.378-.378-.757-.378-.757,0-.378,0-.757-.378l-3.027-.378a28.683,28.683,0,0,1-6.054-2.27c-1.892-.378-7.946-4.919-9.459-6.054a5.224,5.224,0,0,1-1.135-1.514A5.225,5.225,0,0,1,29.315,84a21.634,21.634,0,0,1-2.649-3.027,32.735,32.735,0,0,1-2.649-3.784,51.279,51.279,0,0,1-3.784-7.946l-.378-.378v-.757c-1.135-2.649-1.892-9.081-1.892-12.486-.378-3.027.378-9.838,1.514-12.108.757-2.27,2.649-7.189,3.784-8.7.378-.378.378-.757.757-1.135a2.912,2.912,0,0,0,.757-1.135c.378-.378.378-.757,1.135-1.135,0-.757,0-.378.757-.757A6.1,6.1,0,0,1,28.18,28a12,12,0,0,0,2.27-1.892c1.135-1.135,3.4-3.405,4.541-3.784l.757-.757c.378-.378,1.135-.757,1.514-1.135.757-.378,1.135-.757,1.892-.757a2.869,2.869,0,0,1,1.514-.757,29.183,29.183,0,0,1,7.189-3.027l3.027-.757h1.892c1.892-.757,7.946-.757,10.216-.378l3.027.378h.757c.757,0,2.649.378,3.027,1.135.757,0,2.27,0,3.027.757,2.649.757,7.946,3.405,9.459,4.919,3.027,1.514,9.838,8.7,11.351,12.108,1.135.757,3.027,4.919,3.4,6.432.378.757,1.513,4.919,1.892,6.432a41.9,41.9,0,0,1,.757,7.189C100.072,57.891,99.315,65.837,97.8,68.864ZM53.91,5.676a18.429,18.429,0,0,1-9.081,0A3.411,3.411,0,0,1,42.937,5.3H42.18c-.757-.378-.378-.378-.757-.378L38.4,4.162A10.1,10.1,0,0,0,31.586,5.3a16.021,16.021,0,0,0-2.649,1.892C27.8,7.57,27.423,8.7,26.667,9.084l-.378.378a11.782,11.782,0,0,1-1.514,2.27,35.817,35.817,0,0,1-1.892,6.811,9.347,9.347,0,0,1-1.514,3.405c-1.514,2.649-5.676,7.946-7.946,9.081-.378.757-1.892,1.135-3.027,1.514A11.327,11.327,0,0,1,7.37,34.054a4.559,4.559,0,0,1-1.892,1.892,18.444,18.444,0,0,0-1.514,4.162l-.757,3.027v3.784l.378,2.649c.378.378.378,0,.757.757a9.482,9.482,0,0,1,1.513,2.649A6.1,6.1,0,0,1,7.37,55.621C8.5,57.513,8.883,59.4,9.262,62.432c0,.757.378,2.649,0,3.4,0,.757-.378,2.27-.378,3.027L7.37,74.54l-.378,3.784c.378.757.757,1.892,1.135,2.649a7.015,7.015,0,0,1,.757,2.649c.757.378,1.135,1.514,1.514,2.27a6.643,6.643,0,0,0,1.513,1.892,9.081,9.081,0,0,0,4.541,2.649c.757,0,3.027,0,3.784.757a12.814,12.814,0,0,1,5.676,2.27A8.273,8.273,0,0,1,27.8,94.594a6.641,6.641,0,0,0,1.892,1.514,26.683,26.683,0,0,1,2.649,3.4,22.322,22.322,0,0,0,1.514,3.027c.378,1.135,1.135,2.27,1.514,3.4a33.263,33.263,0,0,0,3.027,2.649c.757,0,.757,0,1.135.757.757,0,1.135.378,1.892.378l3.4,1.135c1.514,0,3.027.757,4.541.757,2.27.378,3.4-.378,4.919-.378.378-.757,0,0,.757-.378,0-.378.378-.378.757-.757a5.222,5.222,0,0,1,1.514-1.135c.378-.757,2.27-1.892,3.4-2.27a9.271,9.271,0,0,1,4.541-1.514c3.4-.757,7.946-.757,10.595.757L78.5,107.08c1.514,0,2.27.378,3.784,0l3.027-1.135a28.21,28.21,0,0,0,4.541-2.649c.757-.757,1.135-.757,1.892-1.892l1.892-1.892c0-1.135.757-1.892.757-3.027a8.9,8.9,0,0,0,.757-3.027,14.369,14.369,0,0,1,2.65-6.432,5.224,5.224,0,0,1,1.135-1.514A5.224,5.224,0,0,1,100.072,84c.378-.378.378-.757,1.135-.757a5.885,5.885,0,0,1,3.027-2.27c4.919-3.027,7.189-3.4,9.459-9.459l.757-3.027a15.518,15.518,0,0,0,.378-4.162l-.378-1.514a29.98,29.98,0,0,0-1.514-3.4A7.733,7.733,0,0,1,111.045,56c-1.514-1.135-2.27-4.162-2.649-6.432-.378-4.162,0-6.811.757-11.351.757-4.162,1.135-6.432-.378-10.6-.378-.378-.378-.757-.757-1.514a5.223,5.223,0,0,1-1.135-1.514l-.757-.757a.371.371,0,0,0-.378-.378c-.378-.757-.757-.757-1.135-1.135s-1.135-.378-1.514-.757c-6.432-1.892-13.243-3.784-17.027-8.7l-.378-.757a14.248,14.248,0,0,1-3.4-5.676A14.11,14.11,0,0,0,78.5,2.27,11.331,11.331,0,0,0,75.477.757,8.9,8.9,0,0,1,72.45,0H66.4c-.378.378-.757.378-1.514.757C61.856,1.892,59.964,4.162,53.91,5.676Z",
    transform: "translate(3159.401 2578)",
    fill: "#54b329",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M84.449,77.013a5.225,5.225,0,0,0-1.513,1.135,5.224,5.224,0,0,0-1.514,1.135c-1.135.757-2.649,1.892-3.4,2.27l-.757.378a5.04,5.04,0,0,1-1.892,1.135,11.834,11.834,0,0,1-3.784,1.892c-.757.378-4.919,2.27-5.676,2.649a3.412,3.412,0,0,1-1.892.378,25.114,25.114,0,0,1-7.568,2.27c-.378.378-1.892.378-2.649.378L48.5,91.77a5.377,5.377,0,0,1,.757,2.27l.757.757c0,.378,0,.378.378.757l1.892,5.3a38.179,38.179,0,0,1,2.649,5.676,9.35,9.35,0,0,1,1.514,3.405l2.649,6.432a29.3,29.3,0,0,1,2.649,6.055c.757,1.135,2.649,5.3,2.649,6.432a37.126,37.126,0,0,1,3.027,6.81h.757l.757-3.783a9.357,9.357,0,0,1,1.513-3.407c-.378-1.135,1.135-4.918,1.514-6.431l.757-2.649,1.892-6.81.757-2.27L76.5,106.9a2.889,2.889,0,0,1,1.892.757,30.169,30.169,0,0,1,6.054,3.027,7.611,7.611,0,0,1,3.027,1.513,26.043,26.043,0,0,1,3.027,1.136l6.432,3.026,6.432,3.027c.378.378,0,.378.378,0l-2.649-6.432-1.135-2.648-2.649-6.433c-.757-.757-2.649-5.3-3.027-6.432,0-.378-2.27-5.3-2.27-6.054-.757-.378-1.135-2.27-1.514-3.4a22.48,22.48,0,0,1-1.513-3.027,9.043,9.043,0,0,1-1.135-3.4c-.378-.378-.378,0-.378-.757L86.341,78.9l-1.135-2.27C84.828,76.635,84.828,77.013,84.449,77.013Z",
    transform: "translate(3179.186 2611.473)",
    fill: "#54b329",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M16.7,81.357c0,1.135-.757,2.27-1.135,3.4a22.307,22.307,0,0,0-1.514,3.027l-2.27,4.919v.757c-.757.757-.378,0-.757.378,0,1.135-1.892,4.541-2.27,6.054l-1.518,3.4L2.318,113.9l-1.135,2.27L.047,118.816c.378.378,1.892-.757,2.649-.757a16.454,16.454,0,0,1,2.649-1.513,7.611,7.611,0,0,0,3.027-1.513c1.135-.379,2.27-1.135,3.405-1.135.378-.757,4.919-2.649,6.054-3.407,1.135-.378,5.3-2.648,6.432-2.648a7.607,7.607,0,0,1,3.027-1.514l1.135,3.027a11.693,11.693,0,0,0,.757,3.027l1.135,3.784,1.514,5.3,1.135,3.783.757,2.27,2.27,7.568h.378l1.514-3.4,3.027-6.81a32.7,32.7,0,0,1,2.649-6.432c.378-1.135,2.27-4.54,2.649-6.055a30,30,0,0,1,1.514-3.4c0-.757,1.892-4.162,2.27-4.919.757-1.892,1.514-3.4,2.27-5.3l.757-1.514c.378-1.514,1.892-4.162,1.892-5.3a35.02,35.02,0,0,1-8.7-1.514l-3.027-.757-3.4-.757c-.757,0-5.3-1.514-6.054-2.27-1.135,0-6.054-2.649-6.432-3.027A47.258,47.258,0,0,1,22.75,80.6l-2.27-1.135a6.644,6.644,0,0,0-1.892-1.513C18.209,78.708,17.453,80.978,16.7,81.357Z",
    transform: "translate(3158.021 2612.048)",
    fill: "#54b329",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(3206 2619.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M5.5,0,11,10H0Z",
    transform: "translate(0 -0.155)",
    fill: "#54b329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    d: "M5.5,0,11,9H0Z",
    transform: "translate(11 12.845) rotate(180)",
    fill: "#54b329"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(3221.253 2619.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-2",
    "data-name": "Polygon 1",
    d: "M5.5,0,11,10H0Z",
    transform: "translate(-0.253 -0.155)",
    fill: "#54b329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2-2",
    "data-name": "Polygon 2",
    d: "M5.5,0,11,9H0Z",
    transform: "translate(10.747 12.845) rotate(180)",
    fill: "#54b329"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(3194 2635.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-3",
    "data-name": "Polygon 1",
    d: "M7,0l7,12H0Z",
    transform: "translate(0 -0.442)",
    fill: "#54b329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2-3",
    "data-name": "Polygon 2",
    d: "M7,0l7,12H0Z",
    transform: "translate(14 15.558) rotate(180)",
    fill: "#54b329"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(3212.303 2635.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-4",
    "data-name": "Polygon 1",
    d: "M7,0l7,12H0Z",
    transform: "translate(-0.303 -0.442)",
    fill: "#54b329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2-4",
    "data-name": "Polygon 2",
    d: "M7,0l7,12H0Z",
    transform: "translate(13.697 15.558) rotate(180)",
    fill: "#54b329"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(3229.691 2635.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-5",
    "data-name": "Polygon 1",
    d: "M7,0l7,12H0Z",
    transform: "translate(0.309 -0.442)",
    fill: "#54b329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2-5",
    "data-name": "Polygon 2",
    d: "M7,0l7,12H0Z",
    transform: "translate(14.309 15.558) rotate(180)",
    fill: "#54b329"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(3182 2597)",
    fill: "none",
    stroke: "#54b329",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.5,
    r: 36.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.5,
    r: 35,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSatisfaction);
export default __webpack_public_path__ + "static/media/customer-satisfaction.48888ef28150c8e191725fcdb5d06eca.svg";
export { ForwardRef as ReactComponent };